import WebSocketClient from '@clients/web-socket.client';
import { ISharedNote } from '@app-types/websocket/sharedinfo.types';

const socket = WebSocketClient.getInstance();

export function updateSharedNote(sharedNote: ISharedNote) {
  socket.sendJSON({
    updateSharedNote: sharedNote,
  });
}

export function seenSharedNote(noteId: number) {
  socket.sendJSON({
    seenSharedNote: noteId
  });
}

export function deleteSharedNote(noteId: number) {
  socket.sendJSON({
    deleteSharedNote: noteId
  });
}

export function updateSharedNoteOrder(order: number[]) {
  socket.sendJSON({
    updateSharedNoteOrder: order
  });
}



// WEBPACK FOOTER //
// ./src/services/sharednote/sharednote.websocket.ts